import { useEffect, useState } from 'react';
import styles from './index.module.scss';
import AddToBag from './AddToBag/addToBag';
import Image from '/components/CustomImage';
import getBundleOptionsArray from '/lib/services/helpers/getBundleOptionsArray';

const StickyAddtoCart = (props) => {

    const {
        isMobileType,
        product,
        websiteID
    } = props

    const [showSticky, setShowSticky] = useState(false);

    useEffect(() => {
        document.body.classList.add('pdpPage');

        let timeoutId;

        const handleScroll = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                const foldElement = document.getElementById("productInfo");
                if (foldElement) {
                    const foldBottom = foldElement.offsetTop + foldElement.offsetHeight;
                    setShowSticky(window.scrollY > foldBottom);
                }
            }, 100);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            document.body.classList.remove('pdpPage');
            window.removeEventListener('scroll', handleScroll);
            clearTimeout(timeoutId);
        };
    }, []);
    
    if (!showSticky) return null;

    return (
        <>
            <div className={styles.addToCartComp}>
                <div className={!isMobileType ? styles.addToCartSec : null}>
                    {!isMobileType && <div className={styles.addToCart}>
                        <Image src={product?.small_image?.url} width={100} height={100} alt={product?.name} loading="lazy"/>
                        <div>
                            <h3>{product?.name}</h3>
                            <p>{product?.product_label}</p>
                        </div>
                    </div>}
                    <div className={!isMobileType ? styles.addToBagSec : null}>
                        <AddToBag
                            storeid={websiteID}
                            id={product.id}
                            name={product.name}
                            sku={product.sku}
                            description={product.short_description.html}
                            slug={product.url_path}
                            image={product.small_image.url}
                            url_path={product.url_key}
                            url_key={product.url_key}
                            price={product.price.regularPrice.amount.value}
                            mprice={product.price_range?.minimum_price.regular_price.value}
                            type={product.type_id}
                            conf={product.configurable_options}
                            pwa_oneliner={product.pwa_oneliner}
                            variants={product.variants}
                            stock={product.stock_status}
                            productLabel={product?.product_label}
                            primaryCategory={product?.primary_category}
                            salableqty={product?.salableqty}
                            bundle_options={getBundleOptionsArray(product)}
                        />
                    </div>
                </div>
            </div>

        </>
        );
};

export default StickyAddtoCart;
